<template>
    <div>
        <v-dialog v-model="UploadStatusDialog" width="400" persistent>
            <v-card>
                <v-card-title class="headline p-10 elc-clubdetails-dialog-header" primary-title>
                    Upload Status
                </v-card-title>
                <v-card-text>
                    <p style="font-size: 18px;color: #477314;">
                        {{successArr.length}} records imported successfully.
                    </p>
                    <div v-if="failArr.length > 0">
                        <p style="font-size: 18px;margin: 0;">{{failArr.length}} records failed.</p>
                        <ul>
                            <li style="font-size: 14px;color: #ff4d4d;" v-for="record in failArr">{{record}}</li>
                        </ul>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="elc-button-radius-color" @click="cancel">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

    export default {
        name: 'UploadStatusDialog',
        components: {},
        props: ['successArr', 'failArr'],
        watch: {
            /*successArr: function (val) {
                this.successedRecordArr = val;
            },*/
        },
        data() {
            return {
                UploadStatusDialog: true,
                // successedRecordArr: [],
            }
        },
        methods: {
            cancel() {
                this.UploadStatusDialog = false;
                this.$emit('closeDialog');
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/Common/UploadStatusDialog.vue